<template>
 <div :class="['c-plan-card item mb-2', data.sku == currentProduct.plan.sku ? 'is-selected' : '', (dateTimeForPlansPromo || isAnyPromo) ? 'mt-3' : '']" @click="slideParent">
    <!-- <span v-if="data.custom_label && data.custom_label.length > 0" class="c-plan-card__label t-label t-label--yellow">{{ data.custom_label }}</span> -->

    <div class="c-plan-card__top d-none d-sm-block">
      <div v-if="dateTimeForPlansPromo" class="promoLabel c-plan-card-big__label-promo">
        <span>{{ (data.custom_label && data.custom_label.length) ? data.custom_label : $t('Deal') }}</span>
      </div>
      <div v-if="data.custom_label && data.custom_label.length && !dateTimeForPlansPromo" class="promoLabel c-plan-card-big__label-promo">
        <span>{{ data.custom_label }}</span>
      </div>
      <div class="d-flex justify-content-between">

        <div class="custom-control custom-radio align-self-center mb-0">
          <input
            :checked="data.sku == currentProduct.plan.sku"
            class="custom-control-input"
            type="radio"
            :id="`${data.sku}`">
          <label class="custom-control-label" :for="data.sku"></label>
        </div>

        <div class="ml-1 mr-3 flex-grow-1">

          <div class="d-flex">
              <p class="t-h2 mb-0">{{ data.name }}</p>
              <p
                v-if="data.characteristics && data.characteristics.length > 0"
                class="d-flex c-plan-card__know-more u-bold u-inline-block u-cursor-pointer"
                data-toggle="modal"
                data-target="#planModal">
                  <!-- <span>{{ $t('More details') }}</span> -->
                  <span class="t-info"></span>
              </p>
              <!-- <p v-if="subtitle" class="t-h2 u-orange2 mb-1">{{ subtitle }}</p> -->
          </div>

          <ul
            v-if="displayedCardCharacteristics && displayedCardCharacteristics.length > 0"
            class="t-text t-text--small u-marg-t-xxxs">
              <li
                v-for="(charac, index) in displayedCardCharacteristics"
                :key="charac.information + '-' + index"
                class="c-plan-card__bullet-point">
                  <!-- <em
                    class="c-plan-card__bullet-icon t-icon t-icon--sm t-icon--bg"
                    :style="`background-image: url(${charac.picto});`"></em> -->
                  <span>{{ charac.information }}</span>
              </li>
          </ul>
        </div>


        <div class="c-pricing text-right u-marg-b-xss d-flex flex-column justify-content-between">
          <template v-if="data.monthly_price != 0">
            <!-- <div v-if="data.monthly_promo_price && data.monthly_promo_price.length > 0 && dateTimeForPlansPromo"
                   class="c-pricing__price u-inline-block">{{ getMonthlyPrice }}</div> -->
            <div class="d-flex justify-content-end align-items-baseline">
              <span class="c-pricing__price">{{ getMonthlyPrice }}</span>
              <!-- v-if="this.currentProduct.plan.plan_promo_subscription_duration && this.currentProduct.plan.plan_promo_subscription_duration.length > 0 && dateTimeForPlansPromo" -->

              <div v-if="data.plan_promo_price_text && data.plan_promo_price_text.length > 0 && dateTimeForPlansPromo"
                   class="c-pricing__muted-text u-inline-block"
                   v-html="$t('Monthly plan') + ' ' + data.plan_promo_price_text + ' ' + data.monthly_price_formatted.replace(/\s/g, '') + $t('Monthly plan')">
              </div>
              <div v-else class="c-pricing__muted-text u-inline-block">{{ $t('Monthly plan') }}</div>
            </div>
            <div class="c-pricing__muted-text" style="margin-bottom: 1px" v-html="planPromoPrice"></div>
          </template>
        </div>
      </div>


    </div>

    <div class="c-plan-card__bottom d-none d-sm-flex justify-content-between">
        <div style="padding-top: 4px;">
          <p class="c-plan-card__bottom__title font-weight-bold u-antialiased">{{ $t('Mobile') }}</p>

        </div>
        <div class="c-pricing text-right" style="padding-top: 2px;">
            <div v-if="(data.base_price !== data.final_price) || (+productInformations.prices[currentProduct.sku].price < +productInformations.instalments[currentProduct.sku].items[0].base_price)"
                 class="c-pricing__muted-text u-bold u-line-through" style="padding-top: 3px;">
              <p v-html="oldMobilePrice"></p>
              <!-- <p v-if="currentProduct.plan.option_value === data.option_value" v-html="oldMobilePrice"></p> -->
              <!-- <div v-else class="u-pad-xxxs"></div> -->
            </div>
            <div class="c-pricing__price u-antialiased">{{ mobilePrice }}</div>
            <div
              v-if="data.instalment_amount"
              v-html="pricing(data.instalment_amount, data.instalment_duration)"
              class="c-pricing__muted-text u-inline-block u-marg-l-xxxs"
              style="margin-top: 2px;">
            </div>
        </div>
    </div>


    <div class="c-plan-card__top d-flex d-sm-none" style="padding: 12px 20px;">
      <div v-if="dateTimeForPlansPromo" class="promoLabel c-plan-card-big__label-promo">
        <span>{{ (data.custom_label && data.custom_label.length) ? data.custom_label : $t('Deal') }}</span>
      </div>
      <div v-if="data.custom_label && data.custom_label.length && !dateTimeForPlansPromo" class="promoLabel c-plan-card-big__label-promo">
        <span>{{ data.custom_label }}</span>
      </div>

      <div v-if="data.monthly_price !== 0" class="d-flex justify-content-between">

        <div class="custom-control custom-radio mb-0" style="margin-top: 18px;">
          <input
            :checked="data.sku == currentProduct.plan.sku"
            class="custom-control-input"
            type="radio"
            :id="`${data.sku}`">
          <label class="custom-control-label" :for="data.sku"></label>
        </div>

        <div class="mx-1 flex-grow-1">

          <div class="d-flex mb-0">
              <p class="t-h2 mb-0">{{ data.name }}</p>
              <p
                v-if="data.characteristics && data.characteristics.length > 0"
                class="d-flex c-plan-card__know-more u-bold u-inline-block u-cursor-pointer"
                data-toggle="modal"
                data-target="#planModal">
                  <!-- <span>{{ $t('More details') }}</span> -->
                  <span class="t-info"></span>
              </p>
              <!-- <p v-if="subtitle" class="t-h2 u-orange2 mb-1">{{ subtitle }}</p> -->
          </div>

          <ul
            v-if="displayedCardCharacteristics && displayedCardCharacteristics.length > 0"
            class="t-text t-text--small mb-1" style="padding: 3px 0;">
              <li
                v-for="(charac, index) in displayedCardCharacteristics"
                :key="charac.information + '-' + index"
                class="c-plan-card__bullet-point">
                  <!-- <em
                    class="c-plan-card__bullet-icon t-icon t-icon--sm t-icon--bg"
                    :style="`background-image: url(${charac.picto});`"></em> -->
                  <span>{{ charac.information }}</span>
              </li>
          </ul>

          <div class="c-pricing">
          <template v-if="data.monthly_price != 0">
              <div v-if="data.monthly_promo_price && data.monthly_promo_price.length > 0 && dateTimeForPlansPromo"
                     class="c-pricing__price u-inline-block">{{ getMonthlyPrice }}</div>
              <div v-else class="c-pricing__price u-inline-block">{{ getMonthlyPrice }}</div>
              <div v-if="data.plan_promo_price_text && data.plan_promo_price_text.length > 0 && dateTimeForPlansPromo"
                   class="c-pricing__muted-text u-inline-block"
                   v-html="$t('Monthly plan') + ' ' + data.plan_promo_price_text + ' ' + data.monthly_price_formatted.replace(/\s/g, '') + $t('Monthly plan')">
              </div>
              <div v-else class="c-pricing__muted-text u-inline-block">{{ $t('Monthly plan') }}</div>
              <div class="c-pricing__muted-text" style="margin-left: 0; font-size: 10px; line-height: 1.3;" v-html="planPromoPrice"></div>
          </template>
          </div>
        </div>


      </div>


      <div v-if="data.monthly_price == 0" class="d-flex justify-content-between align-items-center">

        <div class="custom-control custom-radio align-self-center mb-0">
          <input
            :checked="data.sku == currentProduct.plan.sku"
            class="custom-control-input"
            type="radio"
            :id="`${data.sku}`">
          <label class="custom-control-label" :for="data.sku"></label>
        </div>

        <div class="mx-1 flex-grow-1">

          <div class="d-flex mb-0">
              <p class="t-h2 mb-0">{{ data.name }}</p>
              <p
                v-if="data.characteristics && data.characteristics.length > 0"
                class="d-flex c-plan-card__know-more u-bold u-inline-block u-cursor-pointer"
                data-toggle="modal"
                data-target="#planModal">
                  <!-- <span>{{ $t('More details') }}</span> -->
                  <span class="t-info"></span>
              </p>
              <!-- <p v-if="subtitle" class="t-h2 u-orange2 mb-1">{{ subtitle }}</p> -->
          </div>

          <ul
            v-if="displayedCardCharacteristics && displayedCardCharacteristics.length > 0"
            class="t-text t-text--small mb-1" style="padding: 3px 0;">
              <li
                v-for="(charac, index) in displayedCardCharacteristics"
                :key="charac.information + '-' + index"
                class="c-plan-card__bullet-point">
                  <!-- <em
                    class="c-plan-card__bullet-icon t-icon t-icon--sm t-icon--bg"
                    :style="`background-image: url(${charac.picto});`"></em> -->
                  <span>{{ charac.information }}</span>
              </li>
          </ul>

          <div class="c-pricing">
          <template v-if="data.monthly_price != 0">
              <div v-if="data.monthly_promo_price && data.monthly_promo_price.length > 0 && dateTimeForPlansPromo"
                     class="c-pricing__price u-inline-block">{{ getMonthlyPrice }}</div>
              <div v-else class="c-pricing__price u-inline-block">{{ getMonthlyPrice }}</div>
              <div v-if="data.plan_promo_price_text && data.plan_promo_price_text.length > 0 && dateTimeForPlansPromo"
                   class="c-pricing__muted-text u-inline-block"
                   v-html="$t('Monthly plan') + ' ' + data.plan_promo_price_text + ' ' + data.monthly_price_formatted.replace(/\s/g, '') + $t('Monthly plan')">
              </div>
              <div v-else class="c-pricing__muted-text u-inline-block">{{ $t('Monthly plan') }}</div>
              <div class="c-pricing__muted-text" style="margin-left: 0; font-size: 10px; line-height: 1.3;" v-html="planPromoPrice"></div>
          </template>
          </div>
        </div>


      </div>


    </div>

    <div class="c-plan-card__bottom d-flex d-sm-none justify-content-between flex-column" style="padding: 16px 10px;">
      <p class="c-plan-card__bottom__title u-bold u-antialiased text-right mb-2">{{ $t('Mobile') }}</p>
      <div class="c-pricing text-right">
          <div v-if="(data.base_price !== data.final_price) || (+productInformations.prices[currentProduct.sku].price < +productInformations.instalments[currentProduct.sku].items[0].base_price)"
                class="c-pricing__muted-text u-bold u-line-through" style="padding-top: 3px;">
            <p v-html="oldMobilePrice"></p>
            <!-- <p v-if="currentProduct.plan.option_value === data.option_value" v-html="oldMobilePrice"></p> -->
            <!-- <div v-else class="u-pad-xxxs"></div> -->
          </div>
          <div class="c-pricing__price u-antialiased">{{ mobilePrice }}</div>
          <div
            v-if="data.instalment_amount"
            v-html="pricing(data.instalment_amount, data.instalment_duration)"
            class="c-pricing__muted-text u-inline-block u-marg-l-xxxs"
            style="margin-top: 2px;">
          </div>
      </div>
    </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { CalculateMobilePrice } from './Mixins/CustomOptionsMixins'

  export default {
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      slide: {
        type: Function,
        default: () => {},
      },
      index: {
        type: Number,
        default: 0,
      },
      isPlanSelectedFromUrl: {
        type: Boolean,
        default: () => false
      },
      switch: {
        type: Number,
        default: 0
      },
      isAnyPromo: {
        type: Boolean,
        default: () => false
      }
    },
    computed: {
      ...mapGetters({
        currentProduct: 'GET_CURRENT_PRODUCT',
        productInformations: 'GET_PRODUCT_INFORMATIONS',
        $t: 'GET_TRAD'
      }),
      getMonthlyPrice(){
        let tempValue
        if(this.data.monthly_promo_price && this.data.monthly_promo_price.length > 0 && this.dateTimeForPlansPromo){
          tempValue = this.priceFormatter(Math.max(0, +this.data.monthly_promo_price))
          if(this.switch){
            tempValue = this.priceFormatter(Math.max(0, +this.data.monthly_promo_price - +this.data.subscription_convergent_discount))
          }
        }else{
          tempValue =  this.data.monthly_price_formatted.replace(/[\s€]/g, '')
          if(this.switch){
            tempValue = this.priceFormatter(Math.max(0, +this.data.monthly_price - +this.data.subscription_convergent_discount))
          }
        }
        if(this.productInformations.locale === 'fr'){
          return tempValue.replace('.', ',') + '€'
        }else{
          return '€' + tempValue
        }
      },
      mobilePrice () {
        let optionPrice =  parseFloat(this.data.price) + parseFloat(this.productInformations.prices[this.currentProduct.sku].price);
        return CalculateMobilePrice({optionPrice: optionPrice, currency: this.currentProduct.currency, locale: this.productInformations.locale})
      },
      planPromoPrice () {
          // Check if promo is available
          if (this.data.plan_promo_subscription_duration.length === 0 || !this.dateTimeForPlansPromo) return

          let promo_price_text = this.data.plan_promo_subscription_duration;
          let text_with_discount_for_promo;

          let promoPriceWitchLivebox = this.formatPrice(+this.data.monthly_price - +this.data.subscription_convergent_discount)
          let discountedPrice = this.switch
              ? promoPriceWitchLivebox
              : this.data.monthly_price_formatted;

          if (promo_price_text.length) {
              let monthLabel = promo_price_text === '1'
                  ? this.$t('for %1 month, then <br/>%2/month')
                  : this.$t('for %1 months, then <br/>%2/month');

              text_with_discount_for_promo = monthLabel
                  .replace('%1', promo_price_text)
                  .replace('%2', discountedPrice);
          }

          return text_with_discount_for_promo;
      },
        displayedCardCharacteristics() {
            const characteristics = [...this.data.characteristics];

            if (characteristics && characteristics.length > 0) {
                // Filter characteristics to include only those of type 'card'
                const cardCharacteristics = characteristics.filter(charac => charac.type === 'card');
                // Limit the displayed characteristics to a maximum of 2
                if (cardCharacteristics.length > 2) {
                    return cardCharacteristics.slice(0, 2);
                } else {
                    return cardCharacteristics;
                }
            }
        },
      subtitle: function () {
        if (this.data.subtitle.length !== 0) {
          return this.data.subtitle
        } else {
          return ''
        }
      },
      oldMobilePrice () {
          let optionPrice
          if (this.data.sku === '') {
              optionPrice = parseFloat(this.data.price) + parseFloat(this.productInformations.instalments[this.currentProduct.sku].items[0].base_price);
          } else {
              optionPrice = parseFloat(this.data.base_price);
          }
            return CalculateMobilePrice({
                optionPrice: optionPrice,
                currency: this.currentProduct.currency,
                locale: this.productInformations.locale
            });
        },
        dateTimeForPlansPromo() {
            let startDate
            let endDate
            if (this.data.promo_date_start_1 || this.data.promo_date_end_1) {
                startDate = this.data.promo_date_start_1;
                endDate = this.data.promo_date_end_1;
            } else {
                return false;
            }

            let timezone = this.data.timezone_config;
            var now = new Date();
            var currentTime = now.toLocaleString('sv-SE', {timeZone: timezone});

            return startDate <= currentTime && endDate >= currentTime
        }
    },
    methods: {
        formatPrice(price) {
            if (isNaN(price)) return price;

            const parsedPrice = parseFloat(price);
            const formattedPrice = Number.isInteger(parsedPrice)
                ? parsedPrice.toString()
                : parsedPrice.toFixed(2);

            return this.productInformations.locale === 'en'
                ? `€${formattedPrice}`
                : `${formattedPrice.replace('.', ',')}€`;
        },
      priceFormatter(x) {
        let priceRest = x.toString().split('.')[1]
          if(priceRest > 0){
            return Number.parseFloat(x).toFixed(2)
          }else{
            return Number.parseFloat(x).toFixed(0)
          }
      },
      pricing (instalment_amount, instalment_duration) {
          if (this.currentProduct.plan.device_plan_engagement_duration == 0 && this.currentProduct.plan.instalment_duration == 0 && this.currentProduct.plan.instalment_amount == 0) {
              return this.$t('at checkout,</br>no monthly fee')
          } else
        if (this.productInformations.locale === 'en') {
          if(instalment_duration > 1){
            return this.$t('+ %1/month for <br /> %2 months').replace('%1', `${this.currentProduct.currency}${instalment_amount}`).replace('%2', instalment_duration)
          }
          return this.$t('+ %1/month for <br /> %2 month').replace('%1', `${this.currentProduct.currency}${instalment_amount}`).replace('%2', instalment_duration)
        } else {
          if(instalment_duration > 1){
            return this.$t('+ %1/month for <br /> %2 months').replace('%1', `${instalment_amount}${this.currentProduct.currency}`).replace('%2', instalment_duration)
          }
          return this.$t('+ %1/month for <br /> %2 month').replace('%1', `${instalment_amount}${this.currentProduct.currency}`).replace('%2', instalment_duration)
        }
      },

      slideParent(e) {
        if(e.target.className === 't-info'){
          this.$emit('openPlan', this.index);
          return
        }

        this.$emit('selectPlan', this.index);
      },
    }
  }
</script>
